export const DOI_TUONG_NOP = {
  CA_NHAN: 1,
  DOANH_NGHIEP: 2,
  TO_CHUC: 3,
  CO_QUAN_NHA_NUOC: 4,
};

export const DANH_SACH_DOI_TUONG_NOP = [
  { value: DOI_TUONG_NOP.CA_NHAN, text: "Cá nhân" },
  { value: DOI_TUONG_NOP.DOANH_NGHIEP, text: "Doanh nghiệp" },
  { value: DOI_TUONG_NOP.TO_CHUC, text: "Tổ chức" },
  { value: DOI_TUONG_NOP.CO_QUAN_NHA_NUOC, text: "Cơ quan nhà nước" }
];

export const NOI_DUNG_PAKN = {
  CO_CHE_CHINH_SACH: 14
};

export const LOAI_DU_LIEU_DANH_MUC = {
  LuatPAKN: "LuatPAKN",
  NoiDungPAKN: "NoiDungPAKN",
  NguonPAKN: "NguonPAKN",
  LinhVucPAKN: "LinhVucPAKN"
};

export const FILE_CONST = {
  HELP_TEXT:
    "Chỉ nhận xls, xlsx, ppt, pptx, doc, docx, jpg, jpeg, png, gif. Tổng dung lượng tối đa 30MB.",
  HELP_TEXT_PDF: "Chỉ nhận file PDF.",
  ERROR_TEXT_TYPE:
    "Định dạng file không đúng. Chỉ nhận file xls, xlsx, ppt, pptx, doc, docx, jpg, jpeg, png, gif.",
  ERROR_TEXT_SIZE: "Dung lượng tối đa: 30MB",
  MAX_FILES: 15,
  ACCEPT_FILES: ".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx",
  ACCEPT_FILES_PDF: ".pdf",
  ERROR_TEXT_TYPE_PDF: "Định dạng file không đúng. Chỉ nhận file .pdf.",
  MAX_SIZE: "30MB",
  EMPTY_FILE_TEXT: "Không có file đính kèm nào",
  LOI_UPLOAD_QUA_KICH_THUOC: "Tải lên tối đa 15 file, tổng dung lượng file tối đa: 20MB",
  EXPORT_ERROR_TEXT_TYPE: "Định dạng file không đúng. Chỉ nhận file xlsx.",
  EXPORT_ACCEPT_FILES: ".xlsx"
};
